import React, { useState } from "react";
import { ACCOUNT_ENUM } from "./Route";
import ForgotPassword from "./ForgotPassword";
import Login from "./Login";

const Account: React.FC = () => {
  const [state, setState] = useState<string>(ACCOUNT_ENUM.LOGIN);

  switch (state) {
    case ACCOUNT_ENUM.LOGIN:
      return <Login setPage={setState} />;
    case ACCOUNT_ENUM.FORGOT_PASSWORD:
      return <ForgotPassword setPage={setState} />;
    default:
      return <Login setPage={setState} />;
  }
};

export default Account;
